import React from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';

const { activeBackground, darkInputBorder, fontBody, globalInputSelectedBg, primary, white } = colors;

const ToggleStyled = styled.div``;

const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const fontWeightHigh = 600;
const fontWeightLow = 500;

const Button = styled.button<{ active: boolean }>`
  min-height: 24px;
  padding: 0px 16px;
  min-width: 50px;
  border: 0.5px solid ${darkInputBorder};
  color: ${props => (props.active ? primary : fontBody)};
  background-color: ${props => (props.active ? activeBackground : white)};
  font-weight: ${props => (props.active ? fontWeightHigh : fontWeightLow)};
  line-height: 1em;
  padding: 4px 8px;

  :active,
  :focus {
    outline: none;
  }

  :hover {
    cursor: pointer;
    background-color: ${globalInputSelectedBg} !important;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${Button}:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  ${Button}:last-of-type {
    border-left: none;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

export interface IToggleButtonProps {
  label?: string;
  isPrimaryOptionActive: boolean;
  primaryOptionText: string;
  secondaryOptionText: string;
  onPrimaryOptionClick: () => void;
  onSecondaryOptionClick: () => void;
}

export default ({
  label,
  isPrimaryOptionActive,
  primaryOptionText,
  secondaryOptionText,
  onPrimaryOptionClick,
  onSecondaryOptionClick,
}: IToggleButtonProps) => (
  <ToggleStyled>
    {label && <Label>{label}</Label>}
    <ButtonContainer>
      <Button onClick={onPrimaryOptionClick} active={isPrimaryOptionActive}>
        {primaryOptionText}
      </Button>
      <Button onClick={onSecondaryOptionClick} active={!isPrimaryOptionActive}>
        {secondaryOptionText}
      </Button>
    </ButtonContainer>
  </ToggleStyled>
);
